import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NotificationSystemRoutingModule } from './notification-system-routing.module';
import { NotificationSystemComponent } from './notification-system.component';
import { UserMasterComponent } from './components/user-master/user-master.component';
import { RouterModule, Routes } from '@angular/router';
import { AccountsModule } from '../accounts-module/accounts/accounts.module';


import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { ToastrModule } from 'ngx-toastr';
import { MatPaginatorModule } from "@angular/material/paginator";
import { UserMasterListComponent } from './components/user-master-list/user-master-list.component';
import { TemplateMasterComponent } from './components/template-master/template-master.component';
import { CustomerOnboardingComponent } from './components/customer-onboarding/customer-onboarding.component';
import { ServiceMasterComponent } from './components/service-master/service-master.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ServiceTemplateMapComponent } from './components/service-template-map/service-template-map.component';
import { PromoMsgSchedulerComponent } from './components/promo-msg-scheduler/promo-msg-scheduler.component';
import { TransactionMasterComponent } from './components/transaction-master/transaction-master.component';
import { CustomSmsPopupComponent } from './components/custom-sms-popup/custom-sms-popup.component';
import { TransactionListComponent } from './components/transaction-list/transaction-list.component';
import { UnitMasterComponent } from './components/unit-master/unit-master.component';
import { TransactionMetadataPopupComponent } from './components/transaction-metadata-popup/transaction-metadata-popup.component';
import { SmsListComponent } from './components/sms-list/sms-list.component';
import { TransactionQuotationPopupComponent } from './components/transaction-quotation-popup/transaction-quotation-popup.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component'; 

@NgModule({
  declarations: [
    NotificationSystemComponent,
    UserMasterComponent,
    UserMasterListComponent,
    TemplateMasterComponent,
    CustomerOnboardingComponent,
    ServiceMasterComponent,
    ServiceTemplateMapComponent,
    PromoMsgSchedulerComponent,
    TransactionMasterComponent,
    CustomSmsPopupComponent,
    TransactionListComponent,
    UnitMasterComponent,
    TransactionMetadataPopupComponent,
    SmsListComponent,
    TransactionQuotationPopupComponent,
    UserDashboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AccountsModule,
    NotificationSystemRoutingModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatCardModule,
    MatTabsModule,
    MatAutocompleteModule,
    DragDropModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    ToastrModule.forRoot({
        timeOut: 2500,
        closeButton: true,
        progressBar: true,
        preventDuplicates: true,
        newestOnTop: true
    }),
    
],
  providers: [
    DatePipe,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } }
  ]
})
export class NotificationSystemModule {}
